import { render, staticRenderFns } from "./AdmissionPaymentRule.vue?vue&type=template&id=1956668c&scoped=true&"
import script from "./AdmissionPaymentRule.vue?vue&type=script&lang=js&"
export * from "./AdmissionPaymentRule.vue?vue&type=script&lang=js&"
import style0 from "./AdmissionPaymentRule.vue?vue&type=style&index=0&id=1956668c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1956668c",
  null
  
)

export default component.exports